import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { TOKEN_KEY, url } from 'src/Helpers/utils/Constant';
import { TableLoader, TableNotFound } from 'src/Utils/TableLoader';
import CreateExecutiveMember from './CreateExecutiveMember';
import ExecutivetableRow from './ExecutiveTableRow';
import { IExecutivePanel } from 'src/Types/module/ExecutivePanel/executivepanel';
import ModalsWrapper from 'src/components/Modals/ModalsWrapper';

export default function ExecutivePanel() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [loading, setLoading] = useState(false);
  const [exeutiveMembers, setExeutiveMembers] = useState<
    IExecutivePanel[] | null
  >(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [durations, setDurations] = useState([]);
  const [duration, setDuration] = useState('2024-2025');

  const token = localStorage.getItem(TOKEN_KEY);
  // Modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    setLoading(true);
    (async function () {
      try {
        const uri = `${url}/api/v1/admin/executive?duration=${duration}`;
        const { data } = await axios.get(uri, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log({ data });
        if (data.success) {
          setExeutiveMembers(data.data);
          console.log(data.data, 'dara');
          setLoading(false);
        } else {
          setLoading(false);
        }
        setLoading;
      } catch (error) {
        setLoading(false);
      }
    })();
  }, [refreshTrigger, duration]);

  useEffect(() => {
    const fetchDurationOptions = async () => {
      const { data } = await axios.get(
        `${url}/api/v1/public/executive/durations`
      );

      setDurations(data.data);
    };
    fetchDurationOptions();
  }, []);

  return (
    <Container maxWidth='xl'>
      <Card>
        <>
          <CardHeader
            action={
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 1,
                  alignItems: 'center',
                }}
              >
                <Box>
                  {' '}
                  <Button
                    onClick={() => handleOpen()}
                    variant='contained'
                    sx={{ ml: 2 }}
                  >
                    Create an Executive
                  </Button>
                </Box>
                {durations.length ? (
                  <Box>
                    <FormControl fullWidth>
                      <InputLabel>Duration</InputLabel>
                      <Select
                        value={duration}
                        onChange={(e) => setDuration(e.target.value)}
                        label='Durations'
                        autoWidth
                        size='small'
                      >
                        {durations &&
                          durations?.map((statusOption, i) => (
                            <MenuItem
                              key={statusOption}
                              value={statusOption?.duration}
                            >
                              {statusOption?.duration}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Box>
                ) : (
                  <></>
                )}
              </Box>
            }
            title='Executive Panel List'
          />
          <Divider />

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>SL.</TableCell>
                  <TableCell>Member Info</TableCell>
                  <TableCell>Contact</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Priority</TableCell>
                  <TableCell>Agency</TableCell>
                  <TableCell>Image</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              {loading ? (
                <TableLoader />
              ) : exeutiveMembers?.length ? (
                <TableBody>
                  {exeutiveMembers.map(
                    (exeutiveMember: IExecutivePanel, i: number) => {
                      return (
                        <ExecutivetableRow
                          key={i}
                          index={i}
                          exeutiveMember={exeutiveMember}
                          exeutiveMembers={exeutiveMembers}
                          setExeutiveMembers={setExeutiveMembers}
                          setRefreshTrigger={setRefreshTrigger}
                        />
                      );
                    }
                  )}
                </TableBody>
              ) : (
                <TableNotFound />
              )}
            </Table>
          </TableContainer>
        </>
        {/* create image modal */}

        <ModalsWrapper
          setShowModal={handleClose}
          showModal={open}
          modalData={{ title: 'Create Executive Member' }}
          maxWidth='sm'
        >
          <CreateExecutiveMember
            handleClose={handleClose}
            setRefreshTrigger={setRefreshTrigger}
          />
        </ModalsWrapper>
      </Card>
    </Container>
  );
}
